import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';

import Permissions from './Permissions';
import getPermissionSections from './permissionsData';
import { canUseEngage } from '../../../../common/helpers/users';
import { flagNames, withInjectFeatureFlagsToProps } from '../../../../../modules/infra/feature-flags';

export default compose(
  withInjectFeatureFlagsToProps([flagNames.AUTOPAYOUT_SELF_SERVE]),
  connect(state => ({
    canSeeEngagePermissions: canUseEngage(state),
  })),
  withProps(props => ({
    permissionSections: getPermissionSections({
      canSeeEngagePermissions: props.canSeeEngagePermissions,
      canSeeAutoPayoutPermissions: props[flagNames.AUTOPAYOUT_SELF_SERVE],
    }),
  })),
)(Permissions);
